import { Money } from '../ui';

/**
 * A Balance cell. The three cases mean different things and must not look alike:
 *  - a figure: what is still owed (courier charge included, payments applied — the server's number);
 *  - null: the invoice is cancelled, so nothing is owed;
 *  - anything else: the server did not send a balance. That is a fault, and showing a dash for it (as
 *    this table once did) reads as "nothing owed" on an invoice that may be unpaid. Say so instead.
 */
export function BalanceCell({ balance, currency }: { balance: string | null | undefined; currency: string }) {
  if (balance === null) return <span className="mk-dim" title="Cancelled — nothing is owed">—</span>;
  if (typeof balance !== 'string') {
    return <span className="mk-dim" title="The server did not return a balance for this invoice. Refresh; if it persists, tell support.">Unavailable</span>;
  }
  return <Money amount={balance} currency={currency} />;
}
